import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Survey } from '../../types/surveyData';

export enum ResultTabType {
  Summary = 'SUMMARY',
  Individual = 'INDIVIDUAL',
}

export interface ResultState {
  resultTab: ResultTabType;
  resultDetail: Survey;
  updateDt: Date | null;
}

const initialState: ResultState = {
  resultTab: ResultTabType.Summary,
  resultDetail: {} as Survey,
  updateDt: null,
};

export const resultSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {
    setResultTab(state, action: PayloadAction<ResultTabType>) {
      state.resultTab = action.payload;
    },
    setResultDetail(state, action: PayloadAction<Survey>) {
      state.resultDetail = action.payload;
    },
    setUpdateDt(state, action: PayloadAction<Date>) {
      state.updateDt = action.payload;
    },
  },
});

export const { setResultTab, setResultDetail, setUpdateDt } = resultSlice.actions;
export default resultSlice;
